export const cropperTypes = {
  circle: 'circle',
  barLandscape: 'barLandscape',
  barPortrait: 'barPortrait',
}

export const logoPositions = [
  {
    iconName: 'cipTl',
    value: 'top-left'
  },
  {
    iconName: 'cipTc',
    value: 'top-center',
    style: 'padding: 0 4px 15px;',
    iconStyle: {height: '30px', width: '30px'}
  },
  {
    iconName: 'cipTr',
    value: 'top-right'
  },
  {
    iconName: 'cipBl',
    value: 'bottom-left'
  },
  {
    iconName: 'cipBc',
    value: 'bottom-center',
    style: 'padding: 13px 4px 0;',
    iconStyle: {height: '30px', width: '30px'}
  },
  {
    iconName: 'cipBr',
    value: 'bottom-right'
  },
]